import moment from 'moment'

// Formatting a timestamp in the client specific time zone
// The returned date will always be in the format 'Dec 24, 2020, 18:00'
const formatDateInLocalTimezone = (timestamp) => {
  return moment(timestamp * 1000).format('MMM D, YYYY, HH:mm')
}

export default formatDateInLocalTimezone
